import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';

import BrandGroupCard from './BrandGroupCard';

function BrandGroupingBody({ brandGroups }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (!brandGroups) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (brandGroups.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">No results found</Typography>
      </Box>
    );
  }

  const paginatedGroups = brandGroups.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <Box sx={{ width: '100%' }}>
      <div className="mt-0" style={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: 650 }} aria-label="brand groups table">

          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow sx={{ height: '56px' }}>
              <TableCell sx={{ fontWeight: 'bold', minWidth: '100px' }}>Group Id</TableCell>
              <TableCell sx={{ fontWeight: 'bold', minWidth: '200px' }}>Brand Group</TableCell>
              <TableCell sx={{ fontWeight: 'bold', minWidth: '300px' }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', minWidth: '150px' }}>Edit</TableCell>
              <TableCell sx={{ fontWeight: 'bold', minWidth: '100px' }}>Delete</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedGroups.map((group) => (
              <BrandGroupCard
                key={group.BrandGroupId}
                group={group}
              />
            ))}
          </TableBody>
        </Table>
      </div>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={brandGroups.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          borderTop: '1px solid #e0e0e0',
          '& .MuiTablePagination-toolbar': {
            padding: '8px 16px',
          },
          '& .MuiTablePagination-selectLabel': {
            margin: 0,
          },
          '& .MuiTablePagination-displayedRows': {
            margin: 0,
          },
        }}
      />
    </Box>
  );
}

export default BrandGroupingBody;
